import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Alert } from '@frontend/design-system';
import { useGetUpdateOfficeHoursMethodV2 } from '../../hooks/use-get-update-office-hours-method-v2';
import { OfficeHoursSettings } from './OfficeHoursSettings';

type OfficeHoursSettingsProps = {
  locationId: string;
};

export const OfficeHoursGlobalSettingsV2 = ({ locationId }: OfficeHoursSettingsProps) => {
  const { t } = useTranslation('schedule');

  const { isSaving, onSave, isFetching, officeHoursData, hasOfficeHoursFetchError } =
    useGetUpdateOfficeHoursMethodV2(locationId);

  return (
    <>
      {hasOfficeHoursFetchError && (
        <Alert type='error' css={{ marginTop: theme.spacing(2) }}>
          {t('Unable to fetch appointment hours. Please try again later.')}
        </Alert>
      )}
      <OfficeHoursSettings
        locationId={locationId}
        isLoading={isFetching || isSaving}
        officeHoursData={officeHoursData}
        onSave={onSave}
      />
    </>
  );
};
